/**
 * SHIM for @mui/utils/useEnhancedEffect
 * Fixes initialization issues by avoiding React default object at call sites
 */
import { useLayoutEffect, useEffect } from 'react';

const useEnhancedEffect: typeof useEffect =
  typeof window !== 'undefined'
    ? ((...args) => useLayoutEffect(...args))
    : ((...args) => useEffect(...args));

export default useEnhancedEffect;
